import NewCollection from "../layouts/collections/new";

export default function Home() {
  return (
    <>
      <h1>Home</h1>
      <NewCollection />
    </>
  );
}
